import { isFuture, parseISO } from "date-fns";
import { buildFilmUrl } from "src/lib/buildFilmUrl";
import type { WatchableContent } from "src/lib/movieinfo/movieinfotypes";
import { isFilmwebSearchDocument } from "src/lib/types/search";
import type { ISearchDocument } from "src/lib/types/search";


export function getContentUrl(data: WatchableContent, forceStreaming?: boolean): string {
    //const streamingId = data.id || data.streamingContentId;
    const streamingId = data.streamingContentId;

    return buildFilmUrl(data, null, (!forceStreaming && data.isCinemaRelevant)) ?? ""
}

export function getContentUrlAzSearch(data: ISearchDocument, forceStreaming?: boolean): string {
    if (!isFilmwebSearchDocument(data)) {
        return buildFilmUrl(data) ?? "";
    }

    let isCinemaRelevant = false;

    if (!forceStreaming) {
        if ((data.numShows ?? 0) > 0) {
            isCinemaRelevant = true;
        } else if (data.isCinema && !data.isStreaming) {
            isCinemaRelevant = true;
        } else if (data.movieCinemaPremiere) {
            const parsedPremiere = parseISO(data.movieCinemaPremiere);
            if (isFuture(parsedPremiere)) {
                isCinemaRelevant = true;
            }
        }
    }
    return buildFilmUrl(data, null, isCinemaRelevant) ?? "";
}
